import config from "./config";

export const getPostFileUploadURL = () => {
    const storageCredential = config.storage || {};

    return storageCredential.POST_FILE_UPLOAD_URL
        || "https://www.googleapis.com/upload/storage/v1/b/acuitusag_user_feedbacks/o?uploadType=multipart&name=";
};

export const getLogoUploadURL = () => {
    const storageCredential = config.storage || {};

    return storageCredential.LOGO_FILE_UPLOAD_URL
        || "https://www.googleapis.com/upload/storage/v1/b/acuitusag_organization/o?uploadType=multipart&name=";
};

export const getLogoRetrieveURL = () => {
    const storageCredential = config.storage || {};

    return storageCredential.LOGO_FILE_RETRIEVE_URL
        || "https://storage.googleapis.com/acuitusag_organization/";

}

/* export const getLoadSamplerUploadURL = (farmId, userId) => `https://www.googleapis.com/upload/storage/v1/b/acuitusag_user_feedbacks/o?uploadType=multipart&name=${farmId}/${userId}/`;

export const getLoadSamplerRetrieveURL = (farmId, userId) => `https://storage.googleapis.com/acuitusag_user_feedbacks/${farmId}/${userId}`; */

export const getLoadSamplerUploadURL = (farmId, userId) => `https://www.googleapis.com/upload/storage/v1/b/acuitusag_sampler/o?uploadType=multipart&name=${farmId}/${userId}/`;

export const getLoadSamplerRetrieveURL = (farmId, userId) => `https://storage.googleapis.com/acuitusag_sampler/${farmId}/${userId}`;

export const getFbAppId = () =>
    config && config.oauth && config.oauth.facebook && config.oauth.facebook.CLIENT_ID
        ? config.oauth.facebook.CLIENT_ID : '476931300070091';

export const CHAT_BOT_BASE_URL = 'https://replybot.aximsoft.com/';

// export const CHAT_BOT_BASE_URL = 'http://127.0.0.1:5000';


export const AI_CHAT_BOT_BASE_URL = 'https://geminiagstage.aximsoft.com';
// export const AI_CHAT_BOT_BASE_URL = 'http://localhost:8000';

